import { useState } from 'react';
import logo from '../../images/logo.png';
import { animeLogo } from '../../utils/Effects';

function showHr(elemId, width, alwaysShow = false) {
  if (!alwaysShow) {
    document.getElementById(elemId).style["width"] = `${width}px`;
  }
}

function NavWide(props) {


  const whomehr = props.title === 'home' ? 60 : 0;
  const waboutushr = props.title === 'aboutus' ? 164 : 0;
  const wpriceshr = props.title === 'pricing' ? 74 : 0;

  const homeHrStyle = {
    width: `${whomehr}px`,
  }

  const aboutusHrStyle = {
    width: `${waboutushr}px`,
  }

  const pricesHrStyle = {
    width: `${wpriceshr}px`,
  }

  return (
    <nav className="h-full m10:hidden">
      <ul className="h-full list-none m-0 p-0 flex flex-row gap-3 justify-end">
        <li className="w-max rounded-full flex flex-col-reverse items-center justify-center">
          <hr className="bg-tertiary h-1 rounded-full duration-500" style={homeHrStyle} id="hr-home" />
          <a href='/' className="font-bold no-underline flex items-center px-3.5" onMouseEnter={() => showHr("hr-home", 60)} onMouseLeave={() => showHr("hr-home", 0, props.title === 'home')}>
            Accueil
          </a>
        </li>
        <li className="w-max rounded-full flex flex-col-reverse items-center justify-center">
          <hr className="bg-tertiary h-1 rounded-full duration-500" style={aboutusHrStyle} id="hr-aboutus" />
          <a href='/Qui-sommes-nous' className="font-bold no-underline flex items-center px-3.5" onMouseEnter={() => showHr("hr-aboutus", 164)} onMouseLeave={() => showHr("hr-aboutus", 0, props.title === 'aboutus')}>
            Qui sommes-nous ?
          </a>
        </li>
        <li className="w-max rounded-full flex flex-col-reverse items-center justify-center">
          <hr className="bg-tertiary h-1 rounded-full duration-500" style={pricesHrStyle} id="hr-pricing" />
          <a href='/Tarifs' className="font-bold no-underline flex items-center px-3.5" on onMouseEnter={() => showHr("hr-pricing", 74)} onMouseLeave={() => showHr("hr-pricing", 0, props.title === 'pricing')}>
            Nos tarifs
          </a>
        </li>
        <li className="w-max rounded-full bg-tertiary hover:translate-y-2 duration-300 px-4 flex items-center">
          <a href={`${window.location.href}#contact`} className="font-bold no-underline flex items-center px-3.5 text-primary">
            Contactez-nous
          </a>
        </li>
      </ul>
    </nav>
  );
}

function HamButton(props) {
  return (
    <div className="flex-col hidden m10:flex gap-2 h-full justify-center cursor-pointer" onClick={props.onClick}>
      <hr className={`bg-tertiary h-1 rounded-full w-8 duration-500 ${props.isOpen ? "rotate-405 translate-y-3" : ""}`} id="ham-hr-1" />
      <hr className={`bg-tertiary h-1 rounded-full w-8 duration-500 ${props.isOpen ? "translate-x-4 opacity-0" : ""}`} id="ham-hr-2" />
      <hr className={`bg-tertiary h-1 rounded-full w-8 duration-500 ${props.isOpen ? "-rotate-405 -translate-y-3" : ""}`} id="ham-hr-3" />
    </div>
  );
}

function HamMenu(props) {

  document.body.style["overflow-y"] = props.isOpen ? "hidden" : "scroll";

  return (
    <nav className={`${props.isOpen ? 'translate-y-0' : 'translate-x-[100vw]'} h-ham mt-[var(--header-height)] pt-4 duration-300 hidden m10:block fixed`}>
      <ul className="w-screen p-5 list-none text-primary h-full bg-white m-0 flex flex-col items-center gap-6 text-2xl shadow-xl rounded-l-5xl">
        <li className={`w-full rounded-full justify-center ${props.title === 'home' ? "bg-appbg" : ""} p-3 shadow-lg`}>
          <a href='/' className="font-bold no-underline px-3.5">
            Accueil
          </a>
        </li>
        <li className={`w-full rounded-full justify-center ${props.title === 'aboutus' ? "bg-appbg" : ""} p-3 shadow-lg`}>
          <a href='/Qui-sommes-nous' className="font-bold no-underline px-3.5">
            Qui sommes-nous ?
          </a>
        </li>
        <li className={`w-full rounded-full justify-center ${props.title === 'pricing' ? "bg-appbg" : ""} p-3 shadow-lg`}>
          <a href='/Tarifs' className="font-bold bg- no-underline px-3.5">
            Nos tarifs
          </a>
        </li>
        <li className="w-full rounded-full bg-tertiary p-3 shadow-lg">
          <a href={`${window.location.href}/#contact`} className="font-bold no-underline px-3.5 text-primary" onClick={props.close}>
            Contactez-nous
          </a>
        </li>
      </ul>
    </nav>
  );
}



function Header(props) {

  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="mt-4 absolute h-[var(--header-height)] text-tertiary flex justify-center w-full z-10">
      <HamMenu title={props.title} isOpen={isOpen} close={() => setIsOpen(false)} />
      <div className="flex flex-row justify-between h-full text-md m6:text-lg w-full max-w-7xl px-10 m6:px-4">
        <div className="font-bold flex items-center gap-5 text-4xl m6:text-3xl m6:pl-3 m10:gap-1 h-full m8:rounded-none">
          <img className="opacity-0 h-full m8:h-3/4 -translate-x-60 -rotate-405 duration-[2000ms] m12:duration-1000" src={logo} alt='Logo Snow GMAO' id="header-logo" onLoad={animeLogo} />
          <span className="m10:ml-4">SNOW GMAO</span>
        </div>
        <NavWide title={props.title} />
        <HamButton isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />
      </div>
    </header>
  );
}

export default Header;